import {
    FETCH_ALUNO,
    FETCH_ALUNOS, FETCH_CLASSES, FETCH_DOF,
    FETCH_ESTRUTURA_DISCIPLINAS, POST_ALUNO, POST_ALUNO_AFTER, POST_ALUNO_PRE,
    RECEIVE_ALUNO,
    RECEIVE_ALUNOS, RECEIVE_CLASSES, RECEIVE_DOF,
    RECEIVE_ESTRUTURA_DISCIPLINAS
} from "../actionTypes";
import {AnyAction} from "redux";



export interface iAppReducer {
    isFetching: boolean,
    isPosting: boolean,
}

const initialState : iAppReducer = {
    isFetching: false,
    isPosting: false
}

const appReducer = (state = initialState, action: AnyAction) => {
    
        switch(action.type) {
    
            case FETCH_ALUNOS :
                return {
                    ...state,
                    isFetching : true
                };
    
            case RECEIVE_ALUNOS :
              
                return {
                    ...state,
                    isFetching : false,
                };
            
            case FETCH_ALUNO :
                return {
                    ...state,
                    isFetching : true
                   
                };
            case RECEIVE_ALUNO:
                return {
                    ...state,
                    isFetching : false,
                   
                };
            case FETCH_ESTRUTURA_DISCIPLINAS :
                return {
                    ...state,
                    isFetching : true
                };
            case RECEIVE_ESTRUTURA_DISCIPLINAS :
                return {
                    ...state,
                    isFetching : false,
                   
                };
            case FETCH_CLASSES :
                return {
                    ...state,
                    isFetching : true
                };
            case RECEIVE_CLASSES :
                return {
                    ...state,
                    isFetching : false,
                 
                };
            case FETCH_DOF :
                return {
                    ...state,
                    isFetching : true
                };
            case RECEIVE_DOF :
                return {
                    ...state,
                    isFetching : false,
                   
                };
          
            case POST_ALUNO_PRE :
                return {
                    ...state,
                    isPosting : true
                };
                
            case POST_ALUNO_AFTER :
                return {
                    ...state,
                            isPosting : false
                    };
            case POST_ALUNO :
                return {
                    ...state,
                    isPosting : false
                };
            default:
                return state;
        }
}

export default appReducer;